import { Action } from '@ngrx/store';
import {
  NetflixWebTokenResource,
  TechnicalError,
} from '@dch/products-business-logic';

export const GET_NETFLIX_WEB_TOKEN = 'GET_NETFLIX_WEB_TOKEN';
export const GET_NETFLIX_WEB_TOKEN_SUCCESS = 'GET_NETFLIX_WEB_TOKEN_SUCCESS';
export const GET_NETFLIX_WEB_TOKEN_FAILED = 'GET_NETFLIX_WEB_TOKEN_FAILED';

export class GetNetflixWebToken implements Action {
  type = GET_NETFLIX_WEB_TOKEN;

  constructor(public payload?: any) {}
}

export class GetNetflixWebTokenSuccess implements Action {
  type = GET_NETFLIX_WEB_TOKEN_SUCCESS;

  constructor(public payload: NetflixWebTokenResource) {}
}

export class GetNetflixWebTokenFailed implements Action {
  type = GET_NETFLIX_WEB_TOKEN_FAILED;

  constructor(public payload: TechnicalError) {}
}

export type Actions =
  | GetNetflixWebToken
  | GetNetflixWebTokenSuccess
  | GetNetflixWebTokenFailed;
